import * as React from "react";
import { FC } from "react";
import SvgIcon from "material-ui/SvgIcon";

interface IProps {
    width?: number;
    height?: number;
    color?: string;
    className?: string;
}

export const PlayIcon: FC<IProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 136 136" {...props}>
            <g fill="none" fillRule="evenodd">
                <circle id="Oval" fillOpacity="0.9" fill="#FFFFFF" cx="68" cy="68" r="68" />
                <polygon
                    id="Path-11"
                    stroke="#585858"
                    strokeWidth="2"
                    fill="#585858"
                    strokeLinejoin="round"
                    points="51.1743666 36 51.1743666 96.75 97.8994536 66.375"
                />
            </g>
        </SvgIcon>
    );
};
